export default {
  buttons: {
    go_to_basket: 'Siirry ostoskoriin',
  },
};
